import { Component, OnInit} from '@angular/core';
import { MeterService } from 'projects/pplus/src/lib/components/elements/meter/meter.service';

@Component({
  selector: 'app-selfview-meter-cosphi',
  templateUrl: './selfview-meter-cosphi.component.html',
  styleUrls: ['./selfview-meter-cosphi.component.scss'],
  providers: [MeterService]
})
export class SelfviewMeterCosphiComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {
  }
}
